<div class="relative flex flex-col w-full min-h-full max-h-full">
    
    <!-- Header and body in single because its flex-col for footer -->
    <div class="flex">
        <div class="w-26 p-8 items-center">
            <div class="icon-container">
                <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
            </div>
        </div>
        <div class="w-full">

            <!-- Header -->
            <div class="flex flex-0 w-full items-center justify-between pt-4 pr-6">
                <div class="md:text-2xl font-medium">
                   Issues found
                </div>
                <button mat-icon-button [matDialogClose]="undefined">
                    <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
                </button>
            </div>

            <!-- Body -->
            <div class="flex flex-0 pr-6 w-full overflow-hidden">
                <div class="flex flex-col flex-auto sm:mb-18 overflow-y-scroll sm:overflow-y-auto max-w-72 pb-10">
                    <div class="font-semibold">Form is invalid</div>
                    <div *ngFor="let fieldError of errors">
                        <div *ngFor="let error of fieldError.errors">
                            - {{error}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="absolute inset-x-0 bottom-0 py-4 pr-4 pl-1 sm:pr-8 sm:pl-7  border-t dark:border-gray-800 z-10 bg-gray-50 dark:bg-transparent">
        <div class="flex items-end">
          <div class="ml-auto">
                
                <button mat-stroked-button [matDialogClose]="undefined" class="ml-2">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
